import { useState } from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import { rateArticle } from "../lib/api";
import { getStoredEmail } from "../lib/useNewsezeUser";

export default function RateBar({ article, onRated }) {
  const [up, setUp] = useState(article?.rating_up || 0);
  const [down, setDown] = useState(article?.rating_down || 0);
  const [vote, setVote] = useState(null);
  const [busy, setBusy] = useState(false);

  const click = async (v) => {
    if (busy) return;
    setBusy(true);
    const email = getStoredEmail();
    try {
      const r = await rateArticle(article.id, v, email || null);
      setUp(r.rating_up ?? up + (v === 1 ? 1 : 0));
      setDown(r.rating_down ?? down + (v === -1 ? 1 : 0));
      setVote(v);
      onRated?.(r);
    } catch {}
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2" data-testid={`rate-bar-${article?.id}`}>
      <button
        onClick={() => click(1)}
        className={`btn icon ${vote === 1 ? "primary" : ""}`}
        disabled={busy}
        data-testid={`rate-up-${article?.id}`}
      >
        <ThumbsUp size={12} /> {up}
      </button>
      <button
        onClick={() => click(-1)}
        className={`btn icon ${vote === -1 ? "primary" : ""}`}
        disabled={busy}
        data-testid={`rate-down-${article?.id}`}
      >
        <ThumbsDown size={12} /> {down}
      </button>
    </div>
  );
}
